import topRbottomL from "./topRbottomL";
import topLbottomR from "./topLbottomR";
let boundaries = [
  1, 3, 5, 7, 9, 10, 30, 50, 70, 90, 29, 49, 69, 89, 90, 92, 94, 96, 98,
];
function dhamaValidMoves(
  diagonalsOfDhama,
  emptyNode,
  matrixOfPawns,
  boardData,
  prevSquareIndex,
  playerTurn
) {
  let allWays = [];
  let pawnsToEat = [];
  let tempFinalAllWays = [];
  let finalAllWays = [];
  let allDirections = [];
  let recursiveCount = 0;

  const allArraysOfnodeEmpty = Object.values(diagonalsOfDhama).every(
    (arr) => arr.length === 0
  );

  if (allArraysOfnodeEmpty) {
    Object.values(emptyNode).forEach((valueArr) => {
      finalAllWays.push([...valueArr]);
    });
  } else {
    for (const diagonalDirection in diagonalsOfDhama) {
      let tempArray = [];
      let tempArrayallDirec = [];
      if (
        diagonalDirection === "childrenTopLeft" ||
        diagonalDirection === "childrenBottomRight"
      ) {
        const firstIndexPawn = diagonalsOfDhama[diagonalDirection][0];
        if (firstIndexPawn !== undefined) {
          let result = topRbottomL(
            firstIndexPawn,
            matrixOfPawns,
            boardData,
            tempArray,
            allWays,
            recursiveCount,
            prevSquareIndex,
            tempArrayallDirec,
            allDirections,
            playerTurn
          );

          result.allWays = keepLongestSubarrays(result.allWays);
          result.allDirections = keepLongestSubarrays(result.allDirections);


          tempFinalAllWays = result.allDirections;
          pawnsToEat = result.allWays;
        }
      } else {
        const firstIndexPawn = diagonalsOfDhama[diagonalDirection][0];
        if (firstIndexPawn !== undefined) {
          let result = topLbottomR(
            firstIndexPawn,
            matrixOfPawns,
            boardData,
            tempArray,
            allWays,
            recursiveCount,
            prevSquareIndex,
            tempArrayallDirec,
            allDirections,
            playerTurn
          );

          result.allWays = keepLongestSubarrays(result.allWays, "allWays");
          result.allDirections = keepLongestSubarrays(
            result.allDirections,
            "allDirections"
          );


          tempFinalAllWays = result.allDirections;
          pawnsToEat = result.allWays;
        }
      }
    }
  }
  for (const way in pawnsToEat) {
    let lastDirection = tempFinalAllWays[way][tempFinalAllWays[way].length - 1];
    let lastPawnInPawnToEat = pawnsToEat[way][pawnsToEat[way].length - 1];

    const lastValidMoves = returnValidMoves(
      lastDirection[0],
      lastDirection[1],
      lastPawnInPawnToEat,
      matrixOfPawns,
      boardData,
      playerTurn,
      prevSquareIndex
    );
    finalAllWays.push(lastValidMoves);
  }
  return { finalAllWays: finalAllWays, pawnsToEat: pawnsToEat };
}

function keepLongestSubarrays(arrayOfArrays, label) {
  // Find the length of the longest subarray
  const maxLength = Math.max(
    ...arrayOfArrays.map((subarray) => subarray.length)
  );
  // Filter the subarrays with the maximum length
  const longestSubarrays = arrayOfArrays.filter(
    (subarray) => subarray.length === maxLength
  );

  // Remove duplicate subarrays
  if (label === "allWays") {
    const uniqueSubarrays = [
      ...new Set(longestSubarrays.map(JSON.stringify)),
    ].map(JSON.parse);
    return uniqueSubarrays;
  } else {
    return longestSubarrays;
  }
}
function returnValidMoves(
  row,
  col,
  lastPawnInPawnToEat,
  matrixOfPawns,
  boardData,
  playerTurn,
  prevSquareIndex
) {
  const lastRowInPawnToEat = Math.floor(lastPawnInPawnToEat / 10);
  const lastColInPawnToEat = lastPawnInPawnToEat % 10;
  let diagonalRow = lastRowInPawnToEat + row;
  let diagonalCol = lastColInPawnToEat + col;
  let lastValidMoves = [];
  while (
    diagonalRow >= 0 &&
    diagonalRow < matrixOfPawns.length &&
    diagonalCol >= 0 &&
    diagonalCol < matrixOfPawns[0].length
  ) {
    let indexPawn = matrixOfPawns[diagonalRow][diagonalCol];
    let nextPawn = boardData[matrixOfPawns[diagonalRow][diagonalCol]][0];
    if (
      boundaries.includes(indexPawn) &&
      nextPawn !== 0 &&
      matrixOfPawns[diagonalRow][diagonalCol] !== prevSquareIndex
    ) {
      break;
    }
    if (!boundaries.includes(indexPawn)) {
      var nextNextPawn =
        boardData[matrixOfPawns[diagonalRow + row][diagonalCol + col]][0];
      if (playerTurn === 2) {
        if (
          (nextPawn === 1 && nextNextPawn === 1) ||
          (nextPawn === 1 && nextNextPawn === 31) ||
          (nextPawn === 31 && nextNextPawn === 1) ||
          (nextPawn === 31 && nextNextPawn === 31) ||
          (nextPawn === 1 && nextNextPawn === 2) ||
          nextPawn === 2 ||
          (nextPawn === 32 &&
            matrixOfPawns[diagonalRow][diagonalCol] !== prevSquareIndex)
        ) {
          break;
        }
      } else if (playerTurn === 1) {
        if (
          (nextPawn === 2 && nextNextPawn === 2) ||
          (nextPawn === 2 && nextNextPawn === 32) ||
          (nextPawn === 32 && nextNextPawn === 2) ||
          (nextPawn === 32 && nextNextPawn === 32) ||
          (nextPawn === 2 && nextNextPawn === 1) ||
          nextPawn === 1 ||
          (nextPawn === 31 &&
            matrixOfPawns[diagonalRow][diagonalCol] !== prevSquareIndex)
        ) {
          break;
        }
      }
    }

    if (
      nextPawn === 0 ||
      matrixOfPawns[diagonalRow][diagonalCol] === prevSquareIndex
    ) {
      lastValidMoves.push(indexPawn);
    }
    diagonalRow += row;
    diagonalCol += col;
  }
  return lastValidMoves;
}
export default dhamaValidMoves;
